import {
    allFavouritedImagesInStorage,
    isImageFavourited,
    subscribeFavourites,
    subscribeInspirations,
} from 'list/helpers/store';
import { publish, UPDATE_FAVOURITES, UPDATE_INSPIRATIONS } from 'list/pubsub';

function initFavourites() {
    if (window.ikea.favourites === undefined) {
        window.ikea.favourites = {
            agentLoaded: true,
            isImageFavourited,
            allFavouritedImagesInStorage,
        };
    }
    /**
     * Whenever the stored data is updated, we publish a pubsub event
     */
    subscribeFavourites(d => publish(UPDATE_FAVOURITES, d));
    subscribeInspirations(d => publish(UPDATE_INSPIRATIONS, d));
}

export default initFavourites;
